import React from 'react';
const WhyIllumiV2 = ({ copy }) => {
  if (!copy) return null;
  return (
    <section className="iv2-why" data-testid="iv2-why">
      <div className="iv2-container">
        <p className="iv2-section-eyebrow">{copy.eyebrow}</p>
        <h2 className="iv2-section-headline">{copy.headline}</h2>
        <ul className="iv2-why-list">
          {copy.principles.map((p) => (
            <li key={p.id} className="iv2-why-principle" data-testid={`iv2-why-principle-${p.id}`}>{p.text}</li>
          ))}
        </ul>
        <div className="iv2-why-note">
          <span className="iv2-why-note-label">{copy.note_label}</span>
          <p className="iv2-why-note-body">{copy.note_body}</p>
        </div>
      </div>
    </section>
  );
};
export default WhyIllumiV2;
